/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import Brightness1 from '@material-ui/icons/Brightness1';
import objectPath from "object-path";
import ApexCharts from "apexcharts";
import { DropdownCustomToggler, DropdownMenu2 } from "../../dropdowns";
import { useHtmlClassService } from "../../../layout";

export const barColors = ["#baca4f", "#ffffff", "#001a66", "#0acc4b", "#e7403a", "#07b8e4", "#F1AE15", "#4A7DFF", "#b121ce"]

export function MixedWidget6({ className, chartColor = "primary", currentState, fullData, title, chartId, labels, dataActive, dataPresent, dataAbsent, totalAbsent, dataJustify, dataNotActive, dataMore3Present, dataMore3Absent, dataCapacity, dataEmptyCapacity }) {
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      colorsGrayGray500: objectPath.get(
        uiService.config,
        "js.colors.gray.gray500"
      ),
      colorsGrayGray200: objectPath.get(
        uiService.config,
        "js.colors.gray.gray200"
      ),
      colorsThemeBaseColor: objectPath.get(
        uiService.config,
        `js.colors.theme.base.${chartColor}`
      ),
      colorsThemeLightColor: objectPath.get(
        uiService.config,
        `js.colors.theme.light.${chartColor}`
      ),
      fontFamily: objectPath.get(uiService.config, "js.fontFamily"),
    };
  }, [uiService, chartColor]);

  useEffect(() => {
    const element = document.getElementById(chartId);

    if (!element) {
      return;
    }

    const options = getChartOption(layoutProps, labels, dataActive, dataPresent, dataAbsent, dataJustify, dataNotActive, dataMore3Present, dataMore3Absent, dataCapacity, dataEmptyCapacity);
    const chart = new ApexCharts(element, options);
    chart.render();
    return function cleanUp() {
      chart.destroy();
    };
  }, [layoutProps]);

  const columns = [
    {
      dataField: "dormTitle",
      text: "خوابگاه",
    },
    {
      dataField: "capacity",
      text: "ظرفیت خوابگاه",
      style: { color: barColors[0] }
    },

    {
      dataField: "userActive",
      text: "تعداد ساکنین خوابگاه",
      // style: { color: barColors[0] }
    },
    {
      dataField: "emptyCapacity",
      text: "ظرفیت خالی خوابگاه",
      style: { color: barColors[2] }
    },
    {
      dataField: "userPresent",
      text: "حاضرین",
      style: { color: barColors[3] }
    },
    {
      dataField: "userAbsent",
      text: "غائبین",
      style: { color: barColors[4] }
    },
    {
      dataField: "userAbsentJustify",
      text: "غائبین موجه",
      style: { color: barColors[5] }
    },
    {
      dataField: "userNotTrafficToday",
      text: "امروز تردد نداشته اند",
      style: { color: barColors[6] }
    },
    {
      dataField: "userPresentMore3Day",
      text: "بیش از 3 روز حاضر",
      style: { color: barColors[7] }
    },
    {
      dataField: "userAbsentMore3Day",
      text: "بیش از 3 روز غائب",
      style: { color: barColors[8] }
    },

  ];


  return (
    <>
      {/* begin::Tiles Widget 1 */}
      <div
        className={`card card-custom bg-radial-gradient-dark ${className}`}
      >
        {/* begin::Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title font-weight-bolder text-primary">
            {title}
          </h3>
          <div className=" ">
            <div className="badge text-danger" style={{ color: '#baca4f' }}>
              <span className="svg-icon menu-icon" style={{ color: '#baca4f' }}>
                <Brightness1 />
              </span>
              <span className="menu-text ml-1" style={{ color: '#baca4f' }}>
                ظرفیت خوابگاه
              </span>
            </div>



            <div className="badge text-white">
              <span className="svg-icon menu-icon">
                <Brightness1 />
              </span>
              <span className="menu-text ml-1">
                تعداد ساکنین خوابگاه
              </span>
            </div>

            <div className="badge text-danger" style={{ color: '#bbccff' }}>
              <span className="svg-icon menu-icon" style={{ color: '#bbccff' }}>
                <Brightness1 />
              </span>
              <span className="menu-text ml-1" style={{ color: '#bbccff' }}>
                ظرفیت خالی خوابگاه
              </span>
            </div>

            <div className="badge text-success">
              <span className="svg-icon menu-icon">
                <Brightness1 />
              </span>
              <span className="menu-text ml-1">
                حاضرین
              </span>
            </div>
            <div className="badge text-danger">
              <span className="svg-icon menu-icon">
                <Brightness1 />
              </span>
              <span className="menu-text ml-1">
                غائبین
              </span>
            </div>
            <div className="badge text-danger" style={{ color: '#07b8e4' }}>
              <span className="svg-icon menu-icon" style={{ color: '#07b8e4' }}>
                <Brightness1 />
              </span>
              <span className="menu-text ml-1" style={{ color: '#07b8e4' }}>
                غائبین موجه
              </span>
            </div>
            <div className="badge text-primary">
              <span className="svg-icon menu-icon">
                <Brightness1 />
              </span>
              <span className="menu-text ml-1">
                امروز تردد نداشته اند
              </span>
            </div>
            <div className="badge text-info">
              <span className="svg-icon menu-icon">
                <Brightness1 />
              </span>
              <span className="menu-text ml-1">
                بیش از 3 روز حاضر
              </span>
            </div>
            <div className="badge text-info" style={{ color: '#b121ce' }}>
              <span className="svg-icon menu-icon" style={{ color: '#b121ce' }}>
                <Brightness1 />
              </span>
              <span className="menu-text ml-1" style={{ color: '#b121ce' }}>
                بیش از 3 روز غائب
              </span>
            </div>
            {/* <Dropdown className="dropdown-inline" alignRight>
              <Dropdown.Toggle
                className="btn btn-text-white btn-hover-white btn-sm btn-icon border-0"
                variant="transparent"
                id="dropdown-toggle-top"
                as={DropdownCustomToggler}
              >
                <i className="ki ki-bold-more-hor" />
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                <DropdownMenu2 />
              </Dropdown.Menu>
            </Dropdown> */}
          </div>
        </div>
        {/* end::Header */}

        {/* begin::Body */}
        <div className="card-body d-flex flex-column p-0">
          {/* begin::Chart */}
          <div
            id={chartId}
            data-color={chartColor}
            style={{ height: "200" }}
          />
          {/* end::Chart */}

          <div className="card-spacer bg-light card-rounded flex-grow-1">
            <div className="row m-0">

              {/* <div className="col px-8 py-6 mr-8">
                <div className="font-size-sm text-radial-gradient-dark font-weight-bold">
                  جمع غائبین
                </div>
                <div className="font-size-h5 font-weight-bolder mt-2">{totalAbsent}</div>
              </div>

              {labels.map((item, index) =>
                <div key={index} className="col px-8 py-6 ">
                  <div className="font-size-sm text-radial-gradient-dark font-weight-bold">
                    {item}
                  </div>
                  <div className="font-size-h5 font-weight-bolder mt-2">{dataAbsent[index]}</div>
                </div>
              )} */}
              <BootstrapTable
                rowStyle={{ fontSize: 12 }}
                // rowStyle={{ backgroundColor: 'gray' }}
                // rowClasses={rowFormatter}
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={fullData ? fullData : []}
                columns={columns}
              >
              </BootstrapTable>

            </div>
          </div>
        </div>
        {/* end::Body */}
      </div>
      {/* end::Tiles Widget 1 */}
    </>
  );
}

function getChartOption(layoutProps, labels, dataActive, dataPresent, dataAbsent, dataJustify, dataNotActive, dataMore3Present, dataMore3Absent, dataCapacity, dataEmptyCapacity) {
  const options = {
    series: [
      {
        name: "ظرفیت خوابگاه",
        data: dataCapacity,
      },

      {
        name: "تعداد ساکنین خوابگاه",
        data: dataActive,
      },
      {
        name: "ظرفیت خالی خوابگاه",
        data: dataEmptyCapacity,
      },
      {
        name: "حاضرین",
        data: dataPresent,
      },
      {
        name: "غائبین",
        data: dataAbsent,
      },
      {
        name: "غائبین موجه",
        data: dataJustify,
      },
      {
        name: "امروز تردد نداشته اند",
        data: dataNotActive,
      },
      {
        name: "بیش از 3 روز حاضر",
        data: dataMore3Present,
      },
      {
        name: "بیش از 3 روز غائب",
        data: dataMore3Absent,
      },
    ],
    chart: {
      type: "bar",
      height: "200px",
      toolbar: {
        show: false,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true | '<img src="/static/icons/reset.png" width="20">',
          customIcons: []
        },
        export: {
          csv: {
            filename: undefined,
            columnDelimiter: ',',
            headerCategory: 'category',
            headerValue: 'value',
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString()
            }
          },
          svg: {
            filename: undefined,
          },
          png: {
            filename: undefined,
          }
        },
        autoSelected: 'zoom'
      },
      sparkline: {
        enabled: true,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: ["30%"],
        endingShape: "rounded",
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 1,
      colors: ["transparent"],
    },
    xaxis: {
      categories: labels,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: layoutProps.colorsGrayGray500,
          fontSize: "12px",
          fontFamily: layoutProps.fontFamily,
        },
      },
    },
    yaxis: {
      min: 0,
      max: 80,
      labels: {
        style: {
          colors: layoutProps.colorsGrayGray500,
          fontSize: "12px",
          fontFamily: layoutProps.fontFamily,
        },
      },
    },
    fill: {
      type: ["solid", "solid", "solid", "solid", "solid", "solid", "solid"],
      opacity: [0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6],
    },
    states: {
      normal: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      hover: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: "none",
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: "12px",
        fontFamily: layoutProps.fontFamily,
      },
      y: {
        formatter: function (val) {
          return val + " نفر";
        },
      },
      marker: {
        show: false,
      },
    },
    colors: barColors,
    grid: {
      borderColor: layoutProps.colorsGrayGray200,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
      padding: {
        left: 20,
        right: 20,
      },
    },
  };
  return options;
}
